import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { PlatformLinkingState } from 'modules/platform-linking/store/interfaces';
import { useMemo } from 'react';
import { store } from 'redux/store';
import { entityAdapter } from './adapter';

const platformLinkingState = (state: AppState) => state[EntityStoreName.PlatformLinking];

const selectAll = entityAdapter.getSelectors<AppState>(
  (state: AppState) => state[EntityStoreName.PlatformLinking]
).selectAll;

const pkceVerifierSelector = createSelector(
  platformLinkingState,
  (state: PlatformLinkingState) => state.pkce.lichess?.verifier ?? ''
);

const pkceChallengeSelector = createSelector(
  platformLinkingState,
  (state: PlatformLinkingState) => state.pkce.lichess?.challenge ?? ''
);

const selectByIdFactory = (id: string) =>
  createSelector(store.getState, (state: AppState) =>
    entityAdapter.getSelectors(platformLinkingState).selectById(state, String(id))
  );

const internalRedirectSelector = createSelector(
  platformLinkingState,
  (state: PlatformLinkingState) => state.internalRedirectRoute
);

export const platformLinkingSelector = {
  all: selectAll,
  internalRedirect: internalRedirectSelector,
  pkceVerifier: pkceVerifierSelector,
  pkceChallenge: pkceChallengeSelector,
};

export const platformLinkingSelectorFactory = {
  useById: (id: string) => useMemo(() => selectByIdFactory(id), [id]),
};
